/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import React from "react";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-penta-grey-light">
      <div className="container mx-auto py-24 px-4 relative z-20">
        <h1 className="text-3xl font-light text-center mb-8 text-penta-black">
          Privacy Policy
        </h1>
        <div className="legaltext font-sans bg-penta-white p-8 border border-penta-grey-medium">
          <style jsx>{`
            /* Container to center content */
            .legaltext {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            /* Apply to all direct children elements */
            .legaltext > * {
              max-width: 768px;
              width: 100%;
            }

            .legaltext h2 {
              font-size: 1.75rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1rem;
              color: #333;
            }

            .legaltext h3 {
              font-weight: 600;
              margin-top: 1.75rem;
              margin-bottom: 0.75rem;
              color: #444;
            }

            .legaltext h4 {
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.5rem;
              color: #555;
            }

            .legaltext p {
              font-size: 1rem;
              line-height: 1.6;
              margin-bottom: 1rem;
              color: #333;
            }

            .legaltext a {
              color: #3941eb;
              text-decoration: underline;
            }

            .legaltext a:hover {
              color: #00fba9;
            }

            .legaltext ul,
            .legaltext ol {
              margin-bottom: 1rem;
              padding-left: 1.5rem;
            }

            .legaltext li {
              margin-bottom: 0.5rem;
              line-height: 1.6;
            }
          `}</style>
          <p>
            Data Protection is a priority issue for PENTATONIC GmbH and its
            subsidiaries, Pentatonic Ltd and Infinitum Technologies Inc
            (hereinafter referred to as "PENTATONIC GmbH"). Therefore, we want
            to inform you in accordance with the applicable data protection
            provisions about the personal data used when you visit our website
            or use our services and the rights you have as a data protection
            subject.
          </p>
          <h2>
            <strong>1. Legal Basis, Personal Data</strong>
          </h2>

          <p>
            This Privacy Policy is based on the European General Data Protection
            Regulation (GDPR) and the German data protection act
            (Bundesdatenschutzgesetz).
          </p>
          <p>
            Subject to this Privacy Policy are personal data. Personal data
            means any information relating to an identified or identifiable
            natural person ("data subject"). An identifiable natural person is
            one who can be identified, directly or indirectly, in particular by
            reference to an identifier such as a name, an identification number,
            location data, an online identifier or to one or more factors
            specific to the physical, physiological, genetic, mental, economic,
            cultural or social identity of that natural person.
          </p>
          <h2>
            <strong>2. Name and Address of the Controller</strong>
          </h2>

          <p>
            Controller for the purposes of the General Data Protection
            Regulation (GDPR), other data protection laws applicable in Member
            states of the European Union and other provisions related to data
            protection is:
          </p>
          <p>PENTATONIC GmbH</p>
          <p>Greifswalderstr. 51</p>
          <p>10405 Berlin</p>
          <p>Deutschland</p>
          <p>Phone: +49 30 3395 6013</p>
          <p>Email: support@pentatonic.com</p>
          <p>Data Protection Officer is: Philip Mossop</p>
          <h2>
            <strong>3. Cookies</strong>
          </h2>

          <p>
            The Internet pages of the PENTATONIC GmbH use cookies. Cookies are
            text files that are stored in a computer system via an Internet
            browser.
          </p>
          <p>
            Cookies may contain a so-called cookie ID. A cookie ID is a unique
            identifier of the cookie. It consists of a character string through
            which Internet pages and servers can be assigned to the specific
            Internet browser in which the cookie was stored. This allows visited
            Internet sites to identify the internet browser used.
          </p>
          <p>
            Through the use of cookies we can provide the users of this website
            with more user-friendly services that would not be possible without
            the cookie setting. Cookies enable us to optimize the use of our
            websites for the users. An example is a cookie of a shopping cart in
            an online shop that remembers the articles a customer has placed in
            the virtual shopping cart.
          </p>
          <p>
            The data subject may, at any time, prevent the setting of cookies
            through our website by setting the browser preferences accordingly,
            and may thus permanently avoid the setting of cookies. Furthermore,
            cookies already set may be deleted at any time in the browser
            preferences or by other software programs. If the user deactivates
            cookies in his internet browser, not all functions of our website
            may be entirely usable.
          </p>
          <h2>
            <strong>4. Collection of General Data and Information</strong>
          </h2>

          <p>
            The website of the PENTATONIC GmbH collects a series of general data
            and information when a data subject or automated system calls up the
            website. This general data and information are stored in the server
            log files. Collected may be (1) the browser types and versions used,
            (2) the operating system used by the accessing system, (3) the
            website from which an accessing system reaches our website
            (so-called referrers), (4) the sub-websites, (5) the date and time
            of access to the Internet site, (6) an Internet protocol address (IP
            address), (7) the Internet service provider of the accessing system,
            and (8) any other similar data and information that may be used in
            the event of attacks on our information technology systems.
          </p>
          <p>
            When using these general data and information, PENTATONIC GmbH does
            not draw any conclusions in respect of the data subject. Rather,
            this information is needed to (1) deliver the content of our website
            correctly, (2) optimize the content of our website as well as its
            advertisement, (3) ensure the long-term viability of our information
            technology systems and website technology, and (4) provide law
            enforcement authorities with the information necessary for criminal
            prosecution in case of a cyber-attack. Therefore, PENTATONIC GmbH
            analyzes anonymously collected data and information statistically,
            with the aim of increasing the data protection and data security of
            our enterprise, and to ensure an optimal level of protection for the
            personal data we process. The anonymous data of the server log files
            are stored separately from all personal data provided by a data
            subject.
          </p>
          <h2>
            <strong>5. Google Analytics</strong>
          </h2>

          <p>
            On this website we use Google Analytics (with the anonymizer
            function). Google Analytics is a web analytics service. Web
            analytics is the collection, gathering, and analysis of data about
            the behavior of visitors to websites. A web analysis service
            collects, inter alia, data about the website from which a person has
            come (the so-called referrer), which sub-pages were visited, or how
            often and for what duration a sub-page was viewed. Web analytics are
            mainly used for the optimization of a website and in order to carry
            out a cost-benefit analysis of Internet advertising.
          </p>
          <p>
            When using our agentic search functionality, we may collect
            additional analytics data about how you interact with search
            results, which search paths are most effective, and other
            performance metrics. This analytics data helps us improve the
            quality and relevance of search results for all users and is
            processed in an anonymized form whenever possible.
          </p>
          <h2>
            <strong>6. Agentic Search Technology and Data Processing</strong>
          </h2>

          <p>
            PENTATONIC GmbH offers agentic search functionality, an AI-powered
            search system that actively interprets user queries, autonomously
            gathers information, and presents personalized results. This section
            outlines how we process personal data in connection with this
            service.
          </p>
          <h3>
            <strong>6.1 Description of Agentic Search Processing</strong>
          </h3>

          <p>
            When you use our agentic search functionality, we process the
            following categories of personal data:
          </p>
          <ul>
            <li>Search queries and related content you provide</li>

            <li>Search history and patterns of usage</li>

            <li>User preferences and settings</li>

            <li>Device information and technical identifiers</li>

            <li>Context-related information needed to fulfill your requests</li>

            <li>
              Information gathered from third-party sources when executing
              searches on your behalf
            </li>
          </ul>
          <p>
            This processing is necessary to provide you with personalized,
            relevant search results and to continuously improve our service. In
            accordance with data minimization principles, we limit our
            collection to only what is necessary to provide the agentic search
            functionality you request.
          </p>
          <p>
            Our agentic search system processes your queries through the
            following steps:
          </p>
          <ol>
            <li>
              <strong>Query Analysis</strong>: Your search query is analyzed
              using natural language processing to understand your intent and
              information needs
            </li>

            <li>
              <strong>Autonomous Information Gathering</strong>: The system
              autonomously searches across various information sources to find
              relevant content
            </li>

            <li>
              <strong>Result Compilation</strong>: Relevant information is
              filtered, ranked, and compiled into a coherent response
            </li>

            <li>
              <strong>Personalization</strong>: If enabled, the system
              customizes results based on your preferences and past interactions
            </li>
          </ol>
          <h3>
            <strong>6.2 Data Retention for Agentic Search</strong>
          </h3>

          <p>We retain data related to your agentic search usage as follows:</p>
          <ul>
            <li>
              Active search queries and immediate context: For the duration
              necessary to complete your request
            </li>

            <li>
              Search history and patterns: For up to 12 months to provide
              personalized services
            </li>

            <li>
              User preferences and settings: Until you delete your account or
              change your preferences
            </li>

            <li>
              Interaction data (clicks, view time): For up to 6 months to
              improve relevance
            </li>

            <li>
              Anonymized and aggregated data for service improvement:
              Indefinitely
            </li>
          </ul>
          <p>
            You can delete your search history and reset your preferences at any
            time through your account settings. When you delete search data, it
            is removed from your visible history within 48 hours and from our
            active systems within 90 days.
          </p>
          <h3>
            <strong>6.3 Personalization of Search Results</strong>
          </h3>

          <p>
            Our agentic search functionality employs personalization techniques
            to provide more relevant search results based on:
          </p>
          <ul>
            <li>Your previous search queries and patterns</li>

            <li>Results you've interacted with in the past</li>

            <li>Preferences you've explicitly set in your account</li>

            <li>Device and location information (when permitted)</li>

            <li>Time of day and search context</li>
          </ul>
          <p>
            Personalization affects how your queries are interpreted, which
            information sources are prioritized, and how results are ranked and
            presented to you. You can control personalization through your
            account settings, including:
          </p>
          <ul>
            <li>Enabling or disabling personalization entirely</li>

            <li>
              Clearing your search history to reset personalization signals
            </li>

            <li>Setting specific topic preferences or exclusions</li>

            <li>
              Using "incognito mode" for searches that won't influence future
              personalization
            </li>
          </ul>
          <h3>
            <strong>6.4 Automated Decision-Making and Profiling</strong>
          </h3>

          <p>
            Our agentic search functionality employs automated decision-making
            and profiling techniques to:
          </p>
          <ul>
            <li>Interpret and refine your search queries</li>

            <li>Determine the most relevant information sources</li>

            <li>
              Personalize search results based on your preferences and past
              interactions
            </li>

            <li>
              Proactively suggest information that may be relevant to your needs
            </li>
          </ul>
          <p>
            These automated processes use algorithms that analyze query
            semantics, assess content relevance, apply personalization models,
            and evaluate information quality. As a result, different users may
            receive different results for the same query, and the system may
            make assumptions about your intent that influence the results you
            see.
          </p>
          <p>
            You have the right not to be subject to decisions based solely on
            automated processing, including profiling, which produces legal
            effects concerning you or similarly significantly affects you,
            except where permitted by applicable law. You can manage your
            personalization preferences in your account settings.
          </p>
          <h3>
            <strong>6.5 Your Rights Regarding Agentic Search Data</strong>
          </h3>

          <p>
            In addition to the rights outlined in Section 10, you have the
            following specific rights regarding your agentic search data:
          </p>
          <ul>
            <li>
              Right to control personalization: You can adjust or disable
              personalization features
            </li>

            <li>
              Right to review and delete search history: You can access and
              delete your past searches
            </li>

            <li>
              Right to opt out of specific data uses: You can selectively limit
              how your data is processed
            </li>

            <li>
              Right to data portability: You can request your search history in
              a structured, commonly used, machine-readable format
            </li>

            <li>
              Right to object: You have the right to object at any time to
              processing of your personal data based on legitimate interests
            </li>
          </ul>
          <p>
            To exercise these rights, please contact our Data Protection Officer
            as specified in Section 2.
          </p>
          <h2>
            <strong>7. International Data Transfers</strong>
          </h2>

          <p>
            When transferring your data outside the European Economic Area in
            connection with our agentic search service or other operations, we
            rely on EU Standard Contractual Clauses, adequacy decisions, or
            other appropriate safeguards as required by GDPR. We maintain a list
            of countries to which your data may be transferred and the
            safeguards implemented for each transfer operation. You can request
            detailed information about these safeguards by contacting our Data
            Protection Officer.
          </p>
          <p>
            Where we operate as joint controllers with third-party services or
            partners, we ensure that the essence of these arrangements is made
            available to you upon request, including the respective
            responsibilities for fulfilling GDPR obligations.
          </p>
          <h2>
            <strong>8. Data Protection Impact Assessment</strong>
          </h2>

          <p>
            We conduct Data Protection Impact Assessments for our agentic search
            processing activities to identify and minimize data protection
            risks. These assessments help us implement appropriate technical and
            organizational measures to ensure a level of security appropriate to
            the risk.
          </p>
          <p>
            We maintain comprehensive Records of Processing Activities as
            required by GDPR Article 30, documenting all processing activities,
            categories of data subjects and personal data, recipients of
            personal data, and security measures implemented.
          </p>
          <p>
            You may request information about these compliance measures by
            contacting our Data Protection Officer.
          </p>
          <h2>
            <strong>9. Third-Party Information Sources</strong>
          </h2>

          <p>
            When you use our agentic search functionality, the system may access
            third-party information sources to fulfill your requests. This may
            include:
          </p>
          <ul>
            <li>Public web content</li>

            <li>Licensed databases and information repositories</li>

            <li>Partner services with which we have data-sharing agreements</li>
          </ul>
          <p>
            All third-party interactions are conducted in accordance with
            applicable data protection laws. We ensure that appropriate
            safeguards are in place when transferring your data outside the
            European Economic Area.
          </p>
          <h2>
            <strong>10. Rights of the Data Subject</strong>
          </h2>

          <p>
            A) Right of Confirmation Each data subject shall have the right to
            obtain from us the confirmation as to whether personal data in
            respect of him or her are being processed.
          </p>
          <p>
            B) Right of Access Each data subject shall have the right to obtain
            from us free information about his or her personal data stored at
            any time and a copy of this information.
          </p>
          <p>
            C) Right to Rectification Each data subject shall have the right to
            obtain the rectification of inaccurate personal data concerning him
            or her.
          </p>
          <p>
            D) Right to Erasure Each data subject shall have the right to obtain
            the erasure of personal data concerning him or her without undue
            delay, where one of the legal grounds applies.
          </p>
          <p>
            E) Right to Restriction of Processing Each data subject shall have
            the right to obtain restriction of processing where one of the legal
            conditions applies.
          </p>
          <p>
            F) Right to Data Portability Each data subject shall have the right
            to receive the personal data concerning him or her in a structured,
            commonly used and machine-readable format.
          </p>
          <p>
            G) Right to Object Each data subject shall have the right to object,
            on grounds relating to his or her particular situation, at any time,
            to processing of personal data concerning him or her.
          </p>
          <p>
            H) Automated Individual Decision-Making Each data subject shall have
            the right not to be subject to a decision based solely on automated
            processing, including profiling, which produces legal effects
            concerning him or her, or similarly significantly affects him or
            her, except where permitted by applicable law.
          </p>
          <h2>
            <strong>11. Legal Basis for the Processing</strong>
          </h2>

          <p>
            Art. 6(1) lit. a GDPR serves as the legal basis for processing
            operations for which we obtain consent for a specific processing
            purpose, such as our newsletter and certain personalization features
            of our agentic search functionality. If the processing of personal
            data is necessary for the performance of a contract to which the
            data subject is party, as is the case, for example, when we process
            data while you are visiting our website, using our agentic search
            service, or send us a message via our contact form or by using our
            contact data, the processing is based on Article 6(1) lit. b GDPR.
            Additionally, we may process your data based on our legitimate
            interests under Article 6(1) lit. f GDPR, provided these interests
            are not overridden by your fundamental rights and freedoms.
          </p>
          <h2>
            <strong>
              12. Existence of Automated Decision-Making, Profiling
            </strong>
          </h2>

          <p>
            We employ automated decision-making and profiling techniques in our
            agentic search functionality to provide you with personalized,
            relevant search results. This includes analyzing your search
            patterns, preferences, and past interactions to optimize future
            searches. You have the right not to be subject to decisions based
            solely on automated processing, including profiling, which produces
            legal effects concerning you or similarly significantly affects you,
            except where permitted by applicable law. You can manage your
            personalization preferences and limit automated processing through
            your account settings. For more details, please see Section 6.4.
          </p>
          <h2>
            <strong>13. Changes to this Privacy Policy</strong>
          </h2>

          <p>
            We may update this Privacy Policy from time to time in response to
            changing legal, technical or business developments. When we update
            our Privacy Policy, we will take appropriate measures to inform you,
            consistent with the significance of the changes we make. We will
            obtain your consent to any material Privacy Policy changes if and
            where this is required by applicable data protection laws.
          </p>
          <p>
            You can see when this Privacy Policy was last updated by checking
            the "last updated" date displayed at the top of this Privacy Policy.
          </p>
          <h2>
            <strong>14. Contact Us</strong>
          </h2>

          <p>
            If you have any questions about this Privacy Policy, please contact
            our Data Protection Officer at:
          </p>
          <p>
            PENTATONIC GmbH Attn: Data Protection Officer Greifswalderstr. 51
            10405 Berlin Deutschland Email: privacy@pentatonic.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
